var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-box"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"select-item",class:{active: _vm.current === index},on:{"click":function($event){return _vm.select(index)}}},[_vm._v(" "+_vm._s(item.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }